<template>
  <div class="columns">
    <div class="column">

      <!-- Filters Toolbar -->
      <div class="has-background-white rounded-lg pa-md mb-xxs">
        <div class="columns">
          <div class="column">
            <ConnectionInviteFilters :applied-filters="filters" @filter="filter" />
          </div>
          <div class="column is-narrow">
            <b-select v-model="orderBy" expanded @input="sort" size="is-medium">
              <option value="id_desc">Most Recent</option>
              <option value="id_asc">Oldest</option>
            </b-select>
          </div>
          <div class="column is-narrow">
            <b-button type="is-primary" outlined size="is-medium" @click="showCreateInviteModal = true">Invite Partner</b-button>
          </div>
        </div>
      </div>
      <!-- Actions Toolbar -->
      <div class="has-background-white rounded-lg px-md py-md mb-xxs">
        <div class="columns is-vcentered is-mobile">
          <div class="column">
            <div class="has-text-right is-size-7">
              <p v-if="loading">Loading...</p>
              <p v-else-if="total === 1">1 invitation found</p>
              <p v-else>{{ total }} invitations found</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Results -->
      <div style="overflow-x:auto" class="mb-md">
        <b-table
          :data="results"
          :checked-rows.sync="selected"
          :mobile-cards="false"
          :loading="loading"
          hoverable
          class="is-size-7">
          <b-table-column
            field="name"
            label="Sent To"
            v-slot="props">
            {{ props.row.email }}
          </b-table-column>
          <b-table-column
            field="name"
            label="Partner"
            v-slot="props">
            {{ props.row.partner }}
          </b-table-column>
          <b-table-column
            field="name"
            label="Status"
            v-slot="props"
            width="120"
            number>
            <StatusPresenter :invite="props.row" />
          </b-table-column>
          <template slot="empty">
            <div class="py-xxl has-text-grey has-text-centered">
              {{ (loading) ? "Loading data..." : 'No records found!' }}
            </div>
          </template>
        </b-table>
      </div>
      <b-pagination
        :total="total"
        :current.sync="currentPage"
        :rounded="true"
        :per-page="perPage"
        @change="paginate" />
    </div>
    <!-- Modal: Invite Partner -->
    <b-modal
      has-modal-card
      scroll="keep"
      :active.sync="showCreateInviteModal"
      :can-cancel="['x', 'esc']"
      ><CreateConnectionInviteModal @partner:invited="load" />
    </b-modal>
  </div>
</template>

<script>
import Filterable from '@/mixins/Filterable'
import StatusPresenter from '@/components/Presenters/PartnerInvite/Status'
import ConnectionInviteFilters from '../components/Invites/ConnectionInviteFilters'
import CreateConnectionInviteModal from '@/components/Models/ConnectionInvite/CreateConnectionInviteModal'
import { mapGetters } from 'vuex'

export default {
  components: {
    CreateConnectionInviteModal,
    ConnectionInviteFilters,
    StatusPresenter
  },
  computed: {
    ...mapGetters(['api', 'context']),
    endpoint () {
      return this.api.route + '/invites'
    }
  },
  data: function () {
    return {
      key: 'connection.invites',
      showCreateInviteModal: false
    }
  },
  methods: {

  },
  mounted () {
    this.load()
  },
  mixins: [Filterable]
}
</script>
